import { Navigate, Route, Routes } from 'react-router-dom';
import { Footer } from '../features/Institutional/components/Footer';
import { Header } from '../features/Institutional/components/Header';
import { HomePage } from '../features/Institutional/pages/HomePage';
import { PlataformaPage } from '../features/Institutional/pages/PlataformaPage';
import { SolucoesPage } from '../features/Institutional/pages/SolucoesPage';
import { SegmentosPage } from '../features/Institutional/pages/SegmentosPage';
import { TecnologiaPage } from '../features/Institutional/pages/TecnologiaPage';
import { EmpresaPage } from '../features/Institutional/pages/EmpresaPage';
import { ConteudoPage } from '../features/Institutional/pages/ConteudoPage';
import { ContatoPage } from '../features/Institutional/pages/ContatoPage';
import { DemonstracaoPage } from '../features/Institutional/pages/DemonstracaoPage';
import { LoginPage } from '../features/Institutional/pages/LoginPage';

function SiteLayout() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/plataforma" element={<PlataformaPage />} />
        <Route path="/solucoes" element={<SolucoesPage />} />
        <Route path="/segmentos" element={<SegmentosPage />} />
        <Route path="/tecnologia" element={<TecnologiaPage />} />
        <Route path="/empresa" element={<EmpresaPage />} />
        <Route path="/conteudo" element={<ConteudoPage />} />
        <Route path="/contato" element={<ContatoPage />} />
        <Route path="/demonstracao" element={<DemonstracaoPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={<SiteLayout />} />
    </Routes>
  );
}
